module.exports = {"global":{"absentismo":"ausentismo","factura":"el recibo","contact-email":"contactomx@opensalud.es"}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/mx/global-variables.json
// module id = 312
// module chunks = 117